import { FC } from 'react';

import useIsMissingProofOfAddress from 'features/Onboarding/common/useIsMissingProofOfAddress';
import useIsPrimaryApplicant from 'features/Onboarding/common/useIsPrimaryApplicant';
import useVerificationQuery from 'features/Onboarding/common/useVerificationQuery';
import useVerificationStatus from 'features/Onboarding/common/useVerificationStatus';
import { VerificationStatus } from 'features/Onboarding/common/useVerificationStatus/types';
import Page from 'features/Onboarding/legacy/components/Page';
import { OnboardingPageContent } from 'features/Onboarding/pageLayoutStyles';

import useFeatureFlagsSwitcher from '../../../../../common/hooks/useFeatureFlagsSwitcher';
import NewMultiKycContent from '../../../pages/UnderReview/components/MultiKycContent';
import SoloKycContent from '../../../pages/UnderReview/components/SoloKycContent';
import PageProps from '../PageProps';
import BeneficiaryKycContent from './BeneficiaryKycContent';
import MultiKycContent from './MultiKycContent';

const UnderReview: FC<PageProps> = ({ setCurrentPage, user }) => {
  const { isPrimaryApplicant } = useIsPrimaryApplicant();
  const { featureFlags } = useFeatureFlagsSwitcher();

  const verificationQuery = useVerificationQuery(isPrimaryApplicant);

  const { isMissingProofOfAddress } = useIsMissingProofOfAddress();
  const status = useVerificationStatus(
    verificationQuery,
    isMissingProofOfAddress,
  );

  const hasLoaded =
    isPrimaryApplicant === false || verificationQuery.data !== undefined;

  let content = null;

  if (isPrimaryApplicant === false) {
    content = <BeneficiaryKycContent />;
  } else if (status?.multiKycStatus === 'not-shown') {
    content = <SoloKycContent user={user} />;
  } else if (status !== undefined) {
    content = featureFlags.enableStandardOnboardingBeneficiaryFlowRedesign ? (
      <NewMultiKycContent user={user} />
    ) : (
      <MultiKycContent
        isPrimaryApplicant
        setCurrentPage={setCurrentPage}
        status={status as VerificationStatus}
      />
    );
  }

  return (
    <Page data-testid="under-review" loading={!hasLoaded} withNoBackButton>
      <OnboardingPageContent>{content}</OnboardingPageContent>
    </Page>
  );
};

export default UnderReview;
